export default __webpack_public_path__ + "7912d29d1bb0fc646c37a0cb430121ac.svg";